<div class="body-container">
  <div class="content_header"></div>
  <div class="body-sub-container aic jcc">
    <div class="client_container">
      <div>
        <h4>Sélectionnez un client</h4>
        <!-- Sans `label` : le titre au-dessus joue ce rôle, et la liste porte
             déjà son propre libellé. Trois textes pour un seul champ. -->
        <app-form-field class="filter_element">
          <app-select
            label="Sélectionner un client"
            trigger="field"
            selectionMode="single"
            [fullWidth]="true"
            [clearable]="true"
            [options]="optionsClients()"
            [selected]="clientsSelectionnes()"
            (selectionChange)="choisirClient($event)"
          />
        </app-form-field>
      </div>
    </div>

    @if (clientSelection()) {
      <div class="header">
        <h4>Règles de commissions globales</h4>
      </div>
      @if (parametragesGlobauxClient(); as parametrages) {
        @if (parametrages.length > 0) {
          @for (comm of parametrages; track comm.dateDebutApplication) {
            <div class="regles_commissions_defaut">
              <div class="regle_commission">
                <p class="type_commission">Evènement</p>
                <div>
                  <div class="lst_regle">
                    <p>
                      {{
                        recupererLibellePourReglePlace(comm.reglePourPlaces.minimum, comm.reglePourPlaces.pourcentage)
                      }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="regle_commission">
                <p class="type_commission">Abonnements</p>
                <div class="lst_regle">
                  <p>
                    {{
                      recupererLibellePourRegleAbonnement(
                        comm.reglePourAbonnements.minimum,
                        comm.reglePourAbonnements.pourcentage
                      )
                    }}
                  </p>
                </div>
              </div>
              <div class="regle_commission">
                <p class="type_commission">Packs</p>
                <div class="lst_regle">
                  <p>
                    @if (comm.parametragePourLesPacksEstGlobal) {
                      {{
                        recupererLibellePourReglePack(comm.reglePourPacks!.minimum, comm.reglePourPacks!.pourcentage)
                      }}
                    } @else {
                      Pour chaque pack vendu, la commission web Tick&live est définie selon chaque évènement du pack.
                    }
                  </p>
                </div>
              </div>
            </div>
          }
        }
      } @else {
        <p>pas de configuration par défaut</p>
      }
    }
  </div>

  <!-- Gabarits partagés par les trois tableaux : la règle tient sur plusieurs lignes,
       et la colonne d'action garde un bouton en ligne (le `kind: 'actions'` du kit
       rendrait un menu ⋯, ce qui changerait le geste). -->
  <ng-template #gabaritRegleEvenement let-row>
    <span>{{ recupererLibellePourReglePlace(row.reglePourPlaces.minimum, row.reglePourPlaces.pourcentage) }}</span>
  </ng-template>

  <ng-template #gabaritRegleAbonnement let-row>
    <span>{{ recupererLibellePourRegleAbonnement(row.regle.minimum, row.regle.pourcentage) }}</span>
  </ng-template>

  <ng-template #gabaritReglePack let-row>
    <span>
      @if (row.estUnParametrageGlobal === true) {
        {{ recupererLibellePourReglePack(row.regle.minimum, row.regle.pourcentage) }}
      } @else {
        Pour chaque pack vendu, la commission web Tick&live est définie selon chaque évènement du pack
      }
    </span>
  </ng-template>

  <ng-template #gabaritActionEvenement let-row>
    <div class="btnGroupe">
      @if (row.estVerrouille) {
        <app-icon name="warning" appTooltip="acompte déjà fait avec cette règle" />
      }
      <button
        type="button"
        appButton
        variant="danger"
        size="sm"
        iconOnly
        icon="trash"
        label="Supprimer le paramétrage spécifique"
        appTooltip="Supprimer le paramétrage spécifique"
        (click)="openDialogEvenement(row)"
      ></button>
    </div>
  </ng-template>

  <ng-template #gabaritActionAbonnement let-row>
    <div class="btnGroupe">
      @if (row.estVerrouille) {
        <app-icon name="warning" appTooltip="acompte déjà fait avec cette règle" />
      }
      <button
        type="button"
        appButton
        variant="danger"
        size="sm"
        iconOnly
        icon="trash"
        label="Supprimer le paramétrage spécifique"
        appTooltip="Supprimer le paramétrage spécifique"
        (click)="openDialogAbonnement(row)"
      ></button>
    </div>
  </ng-template>

  <ng-template #gabaritActionPack let-row>
    <div class="btnGroupe">
      @if (row.estVerrouille) {
        <app-icon name="warning" appTooltip="acompte déjà fait avec cette règle" />
      }
      <button
        type="button"
        appButton
        variant="danger"
        size="sm"
        iconOnly
        icon="trash"
        label="Supprimer le paramétrage spécifique"
        appTooltip="Supprimer le paramétrage spécifique"
        (click)="openDialogPack(row)"
      ></button>
    </div>
  </ng-template>

  @if (clientSelection()) {
    <div class="body-sub-container aic jcc">
      <h4>Règles de commissions spécifiques</h4>

      <app-tabs
        class="panel_tabs specifiques-tabs"
        [tabs]="onglets"
        [(activeTab)]="ongletActif"
        ariaLabel="Règles de commissions spécifiques"
      >
        <app-tab-panel tabId="evenements">
          <div class="tab-content">
            <div class="header">
              <app-form-field label="Recherche" class="filter_element">
                <app-input [clearable]="true" [formControl]="filtreParametrageSpecifiqueEvenementControl" />
              </app-form-field>
              <button type="button" appButton variant="primary" (click)="voirPanelEvenement.set(true)">
                Ajouter une règle spécifique
              </button>
            </div>
          </div>
          <div class="grid_container">
            <app-table
              [rows]="parametragesSpecifiquesEvenementFiltres()"
              [columns]="colonnesEvenement()"
              [rowId]="identifiantLigne"
              [status]="statutChargement()"
              emptyMessage="Aucune donnée trouvée"
            />
          </div>
        </app-tab-panel>

        <app-tab-panel tabId="abonnements">
          <div class="tab-content">
            <div class="header">
              <app-form-field label="Recherche" class="filter_element">
                <app-input [clearable]="true" [formControl]="filtreParametrageSpecifiqueAbonnementControl" />
              </app-form-field>
              <button type="button" appButton variant="primary" (click)="voirPanelAbonnement.set(true)">
                Ajouter une règle spécifique
              </button>
            </div>
          </div>
          <div class="grid_container">
            <app-table
              [rows]="parametragesSpecifiquesAbonnementFiltres()"
              [columns]="colonnesAbonnement()"
              [rowId]="identifiantLigne"
              [status]="statutChargement()"
              emptyMessage="Aucune donnée trouvée"
            />
          </div>
        </app-tab-panel>

        <app-tab-panel tabId="packs">
          <div class="tab-content">
            <div class="header">
              <app-form-field label="Recherche" class="filter_element">
                <app-input [clearable]="true" [formControl]="filtreParametrageSpecifiquePackControl" />
              </app-form-field>
              <button type="button" appButton variant="primary" (click)="voirPanelPack.set(true)">
                Ajouter une règle spécifique
              </button>
            </div>
          </div>
          <div class="grid_container">
            <app-table
              [rows]="parametragesSpecifiquesPackFiltres()"
              [columns]="colonnesPack()"
              [rowId]="identifiantLigne"
              [status]="statutChargement()"
              emptyMessage="Aucune donnée trouvée"
            />
          </div>
        </app-tab-panel>
      </app-tabs>
    </div>

    <div
      class="panel_background"
      [@showPanel]="voirPanelEvenement()"
      [class.panel_actif]="voirPanelEvenement()"
      (click)="fermerPanelEvenement()"
      (keypress)="fermerPanelEvenement()"
    ></div>
    <div class="panel_container" [@slider]="voirPanelEvenement() ? 'open' : 'close'">
      @if (voirPanelEvenement()) {
        <app-ajouter-commission-evenement></app-ajouter-commission-evenement>
      }
    </div>

    <div
      class="panel_background"
      [@showPanel]="voirPanelAbonnement()"
      [class.panel_actif]="voirPanelAbonnement()"
      (click)="fermerPanelAbonnement()"
      (keypress)="fermerPanelAbonnement()"
    ></div>
    <div class="panel_container" [@slider]="voirPanelAbonnement() ? 'open' : 'close'">
      @if (voirPanelAbonnement()) {
        <app-ajouter-commission-abonnement></app-ajouter-commission-abonnement>
      }
    </div>

    <div
      class="panel_background"
      [@showPanel]="voirPanelPack()"
      [class.panel_actif]="voirPanelPack()"
      (click)="fermerPanelPack()"
      (keypress)="fermerPanelPack()"
    ></div>
    <div class="panel_container" [@slider]="voirPanelPack() ? 'open' : 'close'">
      @if (voirPanelPack()) {
        <app-ajouter-commission-pack></app-ajouter-commission-pack>
      }
    </div>
  }
</div>
